import { CalendarView } from "@/components/calendar";

export default function BrokerCalendar() {
  return <CalendarView />;
}
